import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import { usePageMetadata } from '../../hooks/usePageMetadata';
import styles from "./HomeMods.module.css"
import homemods_logo_nb from "../../assets/images/homemods_logo_nb.svg";
import mylo_home_banner from "../../assets/images/mylo_home_banner_blue.svg";
import mylo_home_banner_short from "../../assets/images/mylo_home_banner_short.svg";

import mylo_home_mods_white_blue from "../../assets/images/mylo_home_mods_white_blue.svg";
import ndis_logo from "../../assets/images/ndis_logo.svg";
import smoke_alarm from "../../assets/images/smoke_alarm.jpg";
import cloud1 from "../../assets/images/cloud1_black.svg";
import cloud2 from "../../assets/images/cloud2_black.svg";
import cloud3 from "../../assets/images/cloud3_black.svg";
import car1 from "../../assets/images/car1_black.svg";
import car2 from "../../assets/images/car2_black.svg";

import Footer from "../Footer"
import Topbar from "../Topbar"


const Banner = () => {
	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_inner_container}>
				<div className={styles.banner_inner}>
					<img src={mylo_home_mods_white_blue}/>

					<div className={styles.banner_heading}>
						<h1 className={`xl3 forma bold ${styles.optimised}`}>Creating Safer Spaces for Everyday Living</h1>
						<h1 className={`xxxxxxl3 forma bold ${styles.non_optimised}`}>Creating Safer Spaces for Everyday Living</h1>

						<div className={styles.ndis_banner_controls}>
							<button className={`${styles.banner_button} ${styles.non_optimised}`}>
								<p className={`xl1 inter medium`}>Make an Enquiry</p>
								<i className="fa-solid fa-calendar-days xl2"></i>
							</button>

							<div className={styles.ndis_main_container}>
								<img src={ndis_logo}/>
							</div>
						</div>
					</div>
				</div>

				<div className={styles.transition_container} style={{ bottom: '-80px' }}>
					<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#1c75ba" }}/>
					<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#1c75ba" }}/>
					<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#1c75ba" }}/>
				</div>
			</div>
		</div>
	)
}

const ServiceMessage = () => {
	return (
		<div className={styles.cmessage_container}>
			<p className={`xxxxl3 forma bold ${styles.cmessage_banner}`}>Specialists in a wide range of accessibility equipment and mobility access modification services tailored to your home</p>
			<p className={`m2 inter light`}>At MYLO, we specialise in delivering high-quality minor and major home modification services that enhance accessibility, safety, and independence for people with disability and the elderly. As a registered NDIS provider, we take a personalised and compassionate approach to every project, ensuring each solution is tailored to suit individual needs and support long-term, independent living.</p>
		</div>
	)
}

const BannerImage = () => {
	return (
		<div className={styles.bannerimg_wrapper}>
			<div className={styles.bannerimg_container}/>
			<p className={`xxxxxl3 forma bold ${styles.bannerimg_banner}`}>Our customised services ensure that participants<br/>have safe, accessible, and well-maintained<br/>homes suited to their individual needs</p>
		</div>
	)
}

const HouseTransition = () => {
	return (
		<div className={styles.house_transition_wrapper}>
			<div className={styles.house_transition_circle}>
				<img src={homemods_logo_nb}/>
			</div>
		</div>
	)
}


const ApprovedServices = ({ scrollToId }) => {
	return (
		<div className={styles.approvedservices_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
			</div>

			<div className={styles.approveservices_inner_container}>
				<div className={styles.approvedservices_heading}>
					<i className={`fa-solid fa-gear xxxxl3 ${styles.approvedservices_icon} ${styles.optimised}`}></i>

					<p className={`xxxxl3 forma bold`}><span>Home Modification</span> Rational</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-gear xxxxl3 ${styles.approvedservices_icon}  ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.approvedservices_subheading_main}`}>Home Modifications are custom-built changes to your home to help you access and use areas of your home.</p>
				<p className={`m2 inter medium ${styles.approvedservices_subheading}`}>Benefits of Home Modifications:</p>
				<p className={`m2 inter light`}>Home modifications do more than just improve accessibility; they help people feel safer, more confident, and in control of their own space. By tailoring the home to suit individual needs, everyday tasks become easier, and independence is supported, making life more comfortable and empowering overall.</p>

				<p className={`m2 inter medium ${styles.approvedservices_subheading}`}>Major Home Modifications:</p>
				<p className={`m2 inter light`}>We provide Major Home Modifications designed to improve accessibility and support long-term independent living. These services include full bathroom modifications, complete kitchen modifications, and any other extensive structural modifications that may be required for the property.</p>

				<button className={`${styles.approvedservices_btn}`} onClick={() => scrollToId("services")}>
					<p className={`m2 inter medium`}>View our Services</p>
					<i className="fa-solid fa-shield-check m3"></i>
				</button>
			</div>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
			</div>
		</div>
	)
}


const Services = ({ scrollToId }) => {
	const [service, setService] = useState("General Home Safety")
	const data = {
		"General Home Safety": ["Door magnets", "Long life door seals", "Door threshold inserts", "Steps & stairs nosing", "Non-slip visibility strips", "Non-slip visibility paint application", "FRP (fibre-reinforced plastic) Grating walkways"],
		"Bathroom Modifications": ["Handheld shower systems", "Shower curtain & tracks", "Easy turn lever taps", "Thermostatic shower & valve", "Fold-down shower seats", "Wall-mounted shower seats", "Shower benches", "Push button door openers", "Anti-Slip tile treatment with no drying time", "Grab rails", "Drop-down rails", "Towel grab rails", "Modular grab rails", "Grab bars", "Special application rails", "Shower grab poles", "Floor to ceiling poles"],
		"Kitchen Modifications": ["Automatic kitchen lighting", "Countertop & kitchen bench height adjustments", "Accessible appliances installation"],
		"Access & Mobility": ["Banister rails", "Handrails", "Bedside grab poles", "Floor slip resistance coating", "External grab rails", "Ramp rails", "Custom made ramps", "Custom made platforms", "Custom made steps", "Threshold ramps"],
		"Property Landscaping & Maintenance": ["General repairs and maintenance", "Improve and clean external home space", "Garden maintenance", "Landscaping and gutter cleaning services", "Easy turn garden taps installation"]
	}

	return (
		<div className={styles.services_container} id="services">
			<div className={styles.inner_services}>
				<div className={styles.services_catheaders}>
					<p className={`xxxxl3 forma bold`}><span>Home Modification</span> Services</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-shield-check xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.approvedservices_subheading_main}`}>All your home modifications, installed the right way.</p>
				<p className={`m2 inter light ${styles.services_catsubheader}`}>At MYLO, we have extensive experience in property adaptations, we’re committed to creating safe, comfortable, and functional spaces that empower our clients to live confidently at home. With a commitment to quality and care, trust MYLO for expert guidance and reliable modifications that make a meaningful difference in everyday living.</p>

				<div className={styles.service_inner}>
					<div className={styles.services_overview_split}>
						<div className={styles.services_overview_item}>
							{Object.keys(data).map((key) => (
								<button onClick={() => setService(key)}><p className={`xl2 inter bold ${service === key && styles.services_overview_active}`}>{key}</p></button>
							))}
						</div>
						
						<div className={styles.services_overview_img}>
							<img src={smoke_alarm}/>
						</div>
					</div>

					<div className={styles.service_bottom_btns}>
						<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-left xl3"></i></div>
						<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-right xl3"></i></div>
					</div>

					<div className={styles.services_subcatheaders}>
						<p className={`xxl3 forma bold`}><span>Modification</span> Solutions</p>
					</div>

					<div className={styles.services_solutions_container}>
						<ul>
							{data[service].map((service) => (
								<li><p className={`m2 inter light`}>{service}</p></li>
							))}
						</ul>
					</div>

					<button className={`${styles.service_bottom_btns_btn}`} onClick={() => scrollToId("packages")}>
						<p className={`m2 inter medium`}>View our Packages</p>
						<i className="fa-solid fa-box-open m3"></i>
					</button>
				</div>
			</div>
		</div>
	)
}


const HouseBanner = () => {
  	const refs = {
    	car1: useRef(null),
    	car2: useRef(null),
    	cloud1: useRef(null),
    	cloud2: useRef(null),
    	cloud3: useRef(null),

    	car1opt: useRef(null),
    	cloud1opt: useRef(null)
  	};

  	const config = [
    	{ key: "car1", speed: 0.3, dir: 1 },
    	{ key: "car2", speed: 0.3, dir: -1 },
    	{ key: "cloud1", speed: 0.2, dir: 1 },
    	{ key: "cloud2", speed: 0.2, dir: -1 },
    	{ key: "cloud3", speed: 0.2, dir: -1 },

    	{ key: "car1opt", speed: 0.025, dir: 1 },
    	{ key: "cloud1opt", speed: 0.025, dir: -1 }
  	];

  	const targetXs = useRef(config.map(() => 0));
  	const currentXs = useRef(config.map(() => 0));

  	useEffect(() => {
    	const handleScroll = () => {
      		const y = window.scrollY;
      		config.forEach((c, i) => {
        		targetXs.current[i] = y * c.speed;
      		});
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });

    	let rafId;
    	const animate = () => {
      		config.forEach((c, i) => {
        		const el = refs[c.key].current;
        		if (!el) return;
        		currentXs.current[i] += (targetXs.current[i] - currentXs.current[i]) * 0.1;
        		el.style.transform = `translateX(${currentXs.current[i] * c.dir}px)`;
      		});

      		rafId = requestAnimationFrame(animate);
    	};

    	rafId = requestAnimationFrame(animate);

    	return () => {
      		window.removeEventListener("scroll", handleScroll);
      		cancelAnimationFrame(rafId);
    	};
  	}, []);


	return (
		<div className={styles.house_banner_container}>
			<img src={mylo_home_banner} className={`${styles.car_banner} ${styles.non_optimised}`}/>
			<img src={car1} className={`${styles.car1} ${styles.non_optimised}`} ref={refs.car1}/>
			<img src={car2} className={`${styles.car2} ${styles.non_optimised}`} ref={refs.car2}/>
			<img src={cloud1} className={`${styles.cloud1} ${styles.non_optimised}`} ref={refs.cloud1}/>
			<img src={cloud2} className={`${styles.cloud2} ${styles.non_optimised}`} ref={refs.cloud2}/>
			<img src={cloud3} className={`${styles.cloud3} ${styles.non_optimised}`} ref={refs.cloud3}/>

			<img src={mylo_home_banner_short} className={`${styles.car_banner} ${styles.optimised}`}/>
			<img src={car1} className={`${styles.car1opt} ${styles.optimised}`} ref={refs.car1opt}/>
			<img src={cloud1} className={`${styles.cloud1opt} ${styles.optimised}`} ref={refs.cloud1opt}/>
		</div>
	)
}


const Packages = () => {
	return (
		<div className={styles.packages_container} id="packages">
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
			</div>

			<div className={styles.packages_inner_container}>
				<HouseTransition/>

				<div className={styles.packages_heading}>
					<i className={`fa-solid fa-box-open xxxxl3 ${styles.safety_icon} ${styles.optimised}`}></i>

					<p className={`xxxxl3 forma bold`}><span>Home Care</span> Packages</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-box-open xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>At Mylo, we specialise in Home Modifications services to support independent living.</p>
				<p className={`m2 inter light ${styles.howitworks_subheading}`}>Mylo’s Home Care Packages are based on a monthly service which includes performing home safety assessments, carrying out minor repairs in the home, providing assistance with decluttering and moving heavy items to support individuals in the Aged Care and disability sectors. Our tailored Home Care Packages are designed to support NDIS providers, SIL/SDA providers and Age Care Home Service Providers to enable additional cost-effective services for their participants. Mylo provides a personalised management portal for all your participants and properties, enabling easy tracking of all jobs and real-time work progress reporting.<br/><br/></p>

				<HouseBanner/>

				<div className={styles.package_list_container}>
					<div className={styles.package_list_header}>
						<p className={`xl3 forma medium ${styles.package_list_heading}`}>Here is what we offer with our Home care Packages</p>

						<a className={styles.package_list_button} href={"tel:+136956"}>
							<p className={`m2 inter medium`}>Call us to discuss which<br/>package is right for you</p>
							<i className="fa-solid fa-phone l3"></i>
						</a>
					</div>

					<div className={styles.package_list}>
						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-info xl1"></i>
								<p className={`l3 forma bold ${styles.package_list_heading}`}>General Assessment</p>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Check for slippery or loose surfaces within the home</p></li>
									<li><p className={`m3 inter light`}>Check for obstacles within the home that may present a risk</p></li>
									<li><p className={`m3 inter light`}>Check for any loose shelving, picture frames or fixtures</p></li>
									<li><p className={`m3 inter light`}>Check for any exposed hazardous materials</p></li>
									<li><p className={`m3 inter light`}>Testing smoke alarms</p></li>
								</ul>
							</div>
						</div>

						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-wrench xl1"></i>
								<p className={`l3 forma bold ${styles.package_list_heading}`}>Minor Repairs</p>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Adjusting/fixing loose door handles</p></li>
									<li><p className={`m3 inter light`}>Adjusting doors</p></li>
									<li><p className={`m3 inter light`}>Clean and oil sliding door tracks</p></li>
									<li><p className={`m3 inter light`}>Changing light bulbs</p></li>
									<li><p className={`m3 inter light`}>Hanging pictures</p></li>
									<li><p className={`m3 inter light`}>Changing tap washers</p></li>
									<li><p className={`m3 inter light`}>General small repairs that may be required within the home</p></li>
								</ul>
							</div>
						</div>

						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-broom xl1"></i>
								<p className={`l3 forma bold ${styles.package_list_heading}`}>Decluttering</p>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Organising spaces for easier movement and accessibility</p></li>
									<li><p className={`m3 inter light`}>Packing, sorting and relocating items</p></li>
									<li><p className={`m3 inter light`}>Removing unwanted items</p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const FrequentlyAskedQuestions = () => {
	const [collapsed, setCollapsed] = useState(0)
	const questions = [
	  {
	    question: "Are you an NDIS-registered provider?",
	    answer: `We are! As an NDIS-registered home modifications provider, we:
	  • Adhere to strict quality and safety standards  
	  • Hold all necessary licences and insurances  
	  • Deliver clear, itemised service agreements  
	  • Engage qualified assessors  
	  • Undergo regular NDIS audits  

	Ensuring compliant, high-quality accessible homes.`
	  },
	  {
	    question: "Do you provide these services for non NDIS clients?",
	    answer: `Yes—we do provide these services for non-NDIS clients as well.  
	Whether you’re self-funded or accessing support through aged care or other organisations, we’re happy to assist.  
	Feel free to reach out if you have any questions or would like to get started.`
	  },
	  {
	    question: "What type of rails do you install?",
	    answer: `We install a comprehensive range of rails to suit virtually any need or location, including:
	  • Fixed Grab Rails (wall-mounted)
	  • Drop-Down Rails (hinged for space-saving)
	  • Towel Grab Rails (dual-purpose support and towel holder)
	  • Modular Grab Rail Systems (customisable lengths and configurations)
	  • Special-Application Rails (e.g., angled or offset mounting)
	  • Banister Rails & Handrails (staircases, hallways, ramps)
	  • Ramp Rails (for custom ramps and platforms)
	  • Floor-to-Ceiling Poles (vertical support poles)
	  • External Grab Rails (weather-resistant for outdoor use)

	All rails are installed by qualified professionals to Australian safety standards and can be finished in a variety of colours and styles to match your décor.  
	If you don’t see your specific requirement listed, please get in touch—our team can design and install custom rail solutions to meet your unique needs.`
	  },
	  {
	    question: "How do I get a quote or book a consultation?",
	    answer: `Simply call 13 MYLO (13 69 56) or visit mylo.com.au.  
	We provide free onsite consultation and itemised quotes tailored to your requirements.`
	  },
	  {
	    question: "Do you handle bathroom modifications?",
	    answer: `Yes—we install handheld shower systems, fold-down and wall-mounted seats, thermostatic valves, shower benches, and apply non-slip tile treatments (no drying time) for full bathroom accessibility.  
	In addition, we also carry out full bathroom modifications.`
	  },
	  {
	    question: "Can you modify kitchens for accessibility?",
	    answer: `Certainly. We offer:
	  • Automatic kitchen lighting  
	  • Countertop and bench-height adjustments  
	  • Accessible appliance installations  

	to make kitchens safer and easier to use.`
	  },
	  {
	    question: "What does the monthly Home Care Package cost, and what’s included?",
	    answer: `Our Home Care Packages start at:
	  • $99 / month + GST for an apartment or unit  
	  • $129 / month + GST for a house or townhouse  

	Each package includes:
	  • A general home safety assessment  
	  • Minor repairs (door adjustments, tap washer changes, light-bulb replacements)  
	  • Decluttering and light-item relocations  
	  • A written safety report  

	Optional add-ons (same billing cycle):
	  • Gardening at $50 / hour + GST or $640 / year  
	  • Gutter cleaning at $290 / year  
	  • Safety compliance checks (gas, electrical & smoke alarms) at $340 / year`
	  },
	  {
	    question: "Are there any additional or hidden fees I should know about?",
	    answer: `At MYLO we strive for transparency, but please note:
	  • GST applies to all service fees  
	  • Credit-card payments incur a 1.8% surcharge  
	  • Cancellation within 24 hours of a scheduled visit may incur a 50% cancellation fee  
	  • Extensive repairs or heavy-item removals outside the standard inclusions require a separate quote and written approval  
	  • Rubbish removal beyond your own bin capacity can be arranged at an agreed additional cost`
	  }
	];


	return (
		<div className={styles.faq_container}>
			<div className={styles.faq_inner_container}>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.non_optimised}`}>Home Modification FAQ's</p>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.optimised}`}>FAQ's</p>

				<div className={styles.faq_main_container}>
					{questions.map((q, index) => (
						<button className={styles.faq_button} onClick={() => setCollapsed(index)}>
							<p className={`l3 forma medium`}>{q.question}</p>

							{collapsed === index &&
								<div className={styles.faq_content}>
									<p className={`m2 inter light`}>{q.answer.replaceAll("•", "")}</p>
								</div>
							}

							<i className={`fa-thin fa-${collapsed === index ? "minus" : "plus"} xxxxl3`}></i>
						</button>
					))}
				</div>
			</div>

			<HouseTransition/>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
			</div>
		</div>
	)
}







const HomeMods = () => {
	usePageMetadata({
		title: "MYLO | Home Modifications",
		description: "Enhance accessibility and comfort with MYLO Home Modifications. Our NDIS-approved team designs and installs ramps, grab rails, bathrooms conversions, and custom solutions to fit your needs."
	});

  	const containerRef = useRef(null);

  	useEffect(() => {
    	const container = containerRef.current;
    	if (!container) return;

    	const children = Array.from(container.children);
    	const observer = new IntersectionObserver((entries, obs) => {
      		entries.forEach(entry => {
        		if (entry.isIntersecting) {
          			entry.target.classList.add(styles.isVisible);
          			obs.unobserve(entry.target);
        		}
      		});
    	}, { threshold: 0.1 });

    	children.forEach(el => {
      		el.classList.add(styles.fadeInSection);
      		observer.observe(el);
    	});

    	return () => observer.disconnect();
  	}, []);

	const scrollToId = (id) => {
  		const el = document.getElementById(id);
  		if (!el) return;

  		const headerOffset = 0;
  		const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
  		const offsetPosition = elementPosition - headerOffset;

  		window.scrollTo({
    		top: offsetPosition,
    		behavior: 'smooth'
  		});
	}

	return (
		<div className={styles.background} ref={containerRef}>
			<Topbar active={"HomeMods"}/>
			<Banner/>
			<ServiceMessage/>
			<BannerImage/>
			<HouseTransition/>
			<ApprovedServices scrollToId={scrollToId}/>

			<Services scrollToId={scrollToId}/>
			<Packages/>
			<FrequentlyAskedQuestions/>

			<Footer/>
		</div>
	)
};

export default HomeMods;